import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { AcountingHeading } from '../common/AcountingHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import SummaryReport from './SummaryReport'
import DetailedReport from './DetailedReport'
import { reportViewDispatchFilter} from '../../../common/constants'
import * as id from '../../Reports/reportId'
import { connect } from 'react-redux'
import { getHisabReportDropData, getHisabReportSummaryData,getHisabReportDetailedData,getHisabReportSummaryDetailedData} from '../../../../store/Acounting/acounting_action'
import moment from 'moment'
import { updateAlert } from '../../../../store/common/common_action'
import { appendToUrl, focusElemnt, navigation3 } from '../../../common/helper'
import * as urls from '../../Reports/oldReportsUrls'
const HisabReport = (props) => {
  const {
    data: { common, reports, acountingReducer },
    getHisabReportDropData,
    getHisabReportSummaryData,
    getHisabReportDetailedData,
    getHisabReportSummaryDetailedData,
    updateAlert
  } = props
  const { loginData } = common
  const { hisabReportDropData, hisabReportSummaryData,hisabReportDetailedData } = acountingReducer
  const reportName = 'Generate Hisab'
  const [reportView, setReportView] = useState(reportViewDispatchFilter?.[0])
  const [viewReport, setViewReport] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [vehicleNo, setVehicleNo] = useState('')
  const [resetFlag, setResetFlag] = useState(false)
  const handleClick1 = () => {
    if (vehicleNo==='' || vehicleNo===" ") {
      updateAlert({ show: true, msg: 'Please Select Vehicle No.' })
    }else if(reportView?.id===0){
      setViewReport(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        BranchID: loginData?.intBranchID,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(toDate).format('YYYY-MM-DD'),
        VehicleNo: vehicleNo?.VehicleNo,
        UserID: loginData?.intUserID,
        VehicleID: vehicleNo?.VehicleID,
      }
      getHisabReportSummaryData(obj)
    }else if (reportView?.id===1) {
      setViewReport(true)
      const obj = {
        CompanyID: loginData?.intCompanyID,
        BranchID: loginData?.intBranchID,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(toDate).format('YYYY-MM-DD'),
        VehicleNo: vehicleNo?.VehicleNo,
        UserID: loginData?.intUserID,
        VehicleID: vehicleNo?.VehicleID,
      }
      getHisabReportSummaryDetailedData(obj).then((res)=>{
        if (res.status == 'Success') {
          let hisabNo=res.Data.Table.reduce((data,obj)=>{data.push(obj.HisabNo);return data},[]).join('^')
          const object = {
            CompanyID: loginData?.intCompanyID,
            BranchID: loginData?.intBranchID,
            HisabNos:hisabNo,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
            VehicleNo: vehicleNo?.VehicleNo,
          }
          getHisabReportDetailedData(object)
        }
      })
    }
    
  }
  const getFilterData = () => {
    const obj = {
      CompanyID: loginData?.intCompanyID,
      BranchID: loginData?.intBranchID,
      dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
      dtToDate: moment(toDate).format('YYYY-MM-DD'),
    }
    getHisabReportDropData(obj)
  }
  const handleClick2=()=>{
    if (reportView?.id===1) {
      updateAlert({ show: true, msg: 'Detail View is Not Available in Old Format.'})
    } else {
      let url = urls.generateHisabReport
      let urlData = urls.generateHisabReportParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDt = moment(fromDate).format('DD-MMM-YYYY')
      urlData.ToDt = moment(toDate).format('DD-MMM-YYYY')
      urlData.VehicleNo = vehicleNo?.VehicleNo
      urlData.VehicleID = vehicleNo?.VehicleID
      urlData.intAllowExportToExcel = 1
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')     
    }
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setVehicleNo(' ')
    setResetFlag(!resetFlag)
    setReportView(reportViewDispatchFilter?.[0])
  }
  useEffect(()=>{
    focusElemnt('fromDate')
  },[])
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'selectCompany'}
              label={'Select Company'}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Date`}
              name={'from_date'}
              id={'fromDate'}
              nextId={'toDate'}
              prevId={'fromDate'}
              value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              name={'to_date'}
              id={'toDate'}
              value={toDate}
              nextId={'GoBtn'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt('GoBtn')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper" >
            <Button
              id="GoBtn"
              variant="contained"
              nextId={'SelectVehicleNo'}
              prevId={'toDate'}
              style={{ ...sx.fullHeight, ...sx.novp }}
              className="btn btn-primary"
              onClick={() => {getFilterData()}}
              onKeyDown={(e)=>navigation3(e,'SelectVehicleNo','toDate',getFilterData)}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'SelectVehicleNo'}
              label={'Select Vehicle No.'}
              data={hisabReportDropData}
              resetFlag={resetFlag}
              nextId={'reportView'}
              prevId={'GoBtn'}
              // defaultvalue={selReportView.name || selReportView}
              // value={selReportView.name || selReportView}
              idKey={`VehicleID`}
              dataKey={`VehicleNo`}
              onSelect={(val) => {{setViewReport(false);setVehicleNo(val)}}}
              isObjArr={true}
              searchPlaceholder={`Search Report`}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'reportView'}
              nextId={'SplitBtn'}
              prevId={'SelectVehicleNo'}
              label={'Report View'}
              data={reportViewDispatchFilter}
              defaultvalue={reportView?.Name || reportViewDispatchFilter}
              idKey={`id`}
              dataKey={`Name`}
              onSelect={(val) => {{setViewReport(false);setReportView(val)}}}
              // isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width="150px"
            />
          </Item>
          <Item sx={sx.itemsx} style={{ cursor: 'pointer' }} onKeyDown={(e) =>navigation3(e,viewReport ? 'test-table-xls-button' : 'fromDate','reportView',() => handleClick1())}>
            <SplitButton
              id1={'SplitBtn'}
              prevID={id.anReportOptions}
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}              
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
      <Box>
        {viewReport ? (
          reportView?.id === 0 ? (
            <SummaryReport
              reportData={hisabReportSummaryData}
              vehicleNo={vehicleNo}
              loginData={loginData}
              toDate={toDate}
              fromDate={fromDate}
            />
          ) : (
            <DetailedReport
              vehicleNo={vehicleNo}
              tableData={hisabReportDetailedData}
              loginData={loginData}
              toDate={toDate}
              fromDate={fromDate}
            />
          )
        ) : (
          ''
        )}
      </Box>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getHisabReportDropData, getHisabReportSummaryData,updateAlert,getHisabReportDetailedData,getHisabReportSummaryDetailedData}
export default connect(mapStateToProps, mapDispatchToProps)(HisabReport)
